import React, { useState, useEffect } from 'react';
import BottomSheetModal from "../../elements/BottomSheetModal";
import QuantityInput from "../../form/QuantityInput";
import ProgressCircular from "../CircularProgress/ProgressCircular";
import { Elements } from '@stripe/react-stripe-js';
import CheckoutForm from '../../../pages/components/stripe/CheckoutForm';
import ProgressShape from '../CircularProgress/ProgressShape';

const DivideBillEqualyNew = ({ 
  isOpen, 
  onClose, 
  total, 
  selectedTip,
  stripePromise,
  tableNumber,
  orderId,
  customTip = "",
  paymentType,
  previousTransactions = [],
  numberOfPerson = 0,
  paymentData = {} 
}) => {
  const tipAmount = customTip ? Number(customTip) : (selectedTip || 0);
  const totalWithTip = total + tipAmount;
  const [totalPeople, setTotalPeople] = useState(numberOfPerson > 1 ? numberOfPerson : 2);
  const [payingFor, setPayingFor] = useState(1);
  const [yourShare, setYourShare] = useState(0);
  const [yourTipShare, setYourTipShare] = useState(0);
  const [progressPercentage, setProgressPercentage] = useState(0);
  const [remainingCalvulation, setRemainingCalculation] = useState(false);

  const peoplePaidFor = paymentData?.splits?.reduce((sum, split) => 
    sum + (split.noOfPerson || 0), 0
  ) || 0;
  
  const totalPaid = previousTransactions?.reduce((sum, txn) => 
    sum + (txn.amount || 0) + (txn.tip || 0), 0
  ) || 0;  
  
  const remainingDue = total - totalPaid;
  const remainingPeople = remainingCalvulation ? totalPeople : totalPeople - peoplePaidFor;

  const isTotalPeopleDisabled = numberOfPerson > 1;

  useEffect(() => {
    if (numberOfPerson > 1) {
      setTotalPeople(numberOfPerson);
    } else {
      setTotalPeople(2);
    }
  }, [numberOfPerson]);

  useEffect(() => {
    if (isOpen) {
      setPayingFor(1);
    }
  }, [isOpen]);

  useEffect(() => {
    if (paymentData?.splits?.length > 0) {
      const count = paymentData?.splits?.length > 0 && paymentData?.splits?.filter((item) => item.splitType !== 'split_amount').length;
      if(totalPaid>0 && count>0){
        setRemainingCalculation(true);
      }else{
        setRemainingCalculation(false);
      }      
    }
  }, [paymentData, totalPaid]);

  useEffect(() => {
    if (totalPeople > 0) {
      const perPersonBillAmount = remainingCalvulation ? remainingDue / totalPeople : total / totalPeople;
      // const perPersonTipAmount = remainingCalvulation ? (remainingDue * tipAmount) / total : (tipAmount / totalPeople);
      // const perPersonTotal = perPersonBillAmount + perPersonTipAmount;

      const calculatedBillShare = perPersonBillAmount * payingFor;
      // const calculatedTipShare = perPersonTipAmount * payingFor;
      // const calculatedTotalShare = perPersonTotal * payingFor;

      setYourShare(calculatedBillShare);
      //setYourTipShare(calculatedTipShare);

      const totalPeoplePaying = remainingCalvulation ? payingFor : peoplePaidFor + payingFor;
      const percentage = (totalPeoplePaying / totalPeople) * 100;
      setProgressPercentage(Math.min(percentage, 100));
    }
  }, [totalPeople, payingFor, total, tipAmount, totalWithTip, peoplePaidFor, remainingDue, remainingCalvulation]);

  const finalPayableAmount = yourShare + Number(tipAmount);

  return (
    <>
      <BottomSheetModal isOpen={isOpen} onClose={onClose} bgclass={"p-0 xls:max-w-sm xls:mx-auto"}>
        <div className="h-dvh max-h-[80dvh] overflow-y-auto pb-5">
          <div className="border-b border-slate-200 mb-3">
            <div className="px-5 mt-4">
              <h2 className="text-lg font-semibold text-[#232222] mb-1">
                Divide the bill equally
              </h2>
              <p className="text-[#9FA1A3] text-base mb-4 font-normal">
                Divide the bill into equal shares for everyone at the table.
              </p>
            </div>
          </div>

          <div className="flex justify-center items-center">
            <ProgressShape 
              value={progressPercentage} 
              max={100} 
              amount={yourShare || total}
              totalPeople={totalPeople} // Pass totalPeople prop
            />
          </div>

          {/* Show payment status info */}
          {peoplePaidFor > 0 && (
            <div className="px-5 mb-4">
              <div className="bg-green-50 border border-green-200 rounded-lg p-3 flex items-start gap-2">
                <i className="fa-solid fa-check-circle text-green-600 text-sm mt-0.5"></i>
                <div className="flex-1">
                  <p className="text-xs text-green-800 font-semibold">
                    Already paid for {peoplePaidFor} out of {totalPeople} people
                  </p>
                  <p className="text-xs text-green-700 mt-1">
                    You can pay for up to {remainingPeople} more {remainingPeople === 1 ? 'person' : 'people'}
                  </p>
                </div>
              </div>
            </div>
          )}

          <div className="px-5 mb-6 space-y-4">
            <div className={`flex items-center justify-between py-3 px-3 rounded-lg border gap-x-1 ${
              isTotalPeopleDisabled 
                ? 'bg-gray-100 border-gray-300' 
                : 'bg-gray-50 border-gray-200'
            }`}>
              <div className="text-base font-medium text-[#232222]">
                Total People
              </div>

              <div className={`flex-shrink-0 rounded-lg ${
                isTotalPeopleDisabled 
                  ? 'bg-gray-200 cursor-not-allowed' 
                  : 'border-gray-300'
              }`}>
                {(isTotalPeopleDisabled && !remainingCalvulation) ? (
                  <div className="flex items-center gap-2">
                    <span className="text-base font-semibold text-gray-600">{totalPeople}</span>
                    <i className="fa-solid fa-lock text-gray-500 text-xs"></i>
                  </div>
                ) : (
                  <QuantityInput
                    value={totalPeople}
                    onChange={(val) => {
                      // Ensure minimum 2 people
                      const newValue = Math.max(2, val);
                      
                      if (newValue >= Math.max(2, peoplePaidFor)) {
                        setTotalPeople(newValue);
                        // Reset payingFor if it exceeds new remaining people
                        const newRemaining = newValue - remainingCalvulation ? totalPeople : peoplePaidFor;
                        if (payingFor > newRemaining) {
                          setPayingFor(Math.min(newRemaining, 1));
                        }
                      }
                    }}
                    min={Math.max(2, peoplePaidFor)} // Minimum 2, or peoplePaidFor if higher
                  />
                )}
              </div>

              <div className="text-base font-normal text-[#9FA1A3] text-right w-28 truncate">
                At your table
              </div>
            </div>

            {/* Info message when disabled */}
            {isTotalPeopleDisabled && (
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 flex items-start gap-2">
                <i className="fa-solid fa-info-circle text-blue-600 text-sm mt-0.5"></i>
                <p className="text-xs text-blue-800">
                  Total people is locked because it was set when the order was created. You can only change who you're paying for.
                </p>
              </div>
            )}
            
            <div className="flex items-center justify-between py-2 border-b border-gray-100 gap-2">
              <div className="text-base font-medium text-[#232222]">
                Paying For
              </div>

              <div className="flex-shrink-0">
                <QuantityInput
                  value={payingFor}
                  onChange={(val) => {
                    // Ensure minimum 1 person and doesn't exceed remaining people
                    const newValue = Math.max(1, Math.min(val, remainingPeople));
                    if (newValue >= 1 && newValue <= remainingPeople) {
                      setPayingFor(newValue);
                    }
                  }}
                  min={1} // Minimum 1 person
                  max={remainingPeople}
                />
              </div>

              <div className="text-base font-normal text-[#232222] text-right w-28 truncate">
                You pay for
              </div>
            </div>

            {/* Info Message */}
            {payingFor > remainingPeople && (
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 flex items-start gap-2">
                <i className="fa-solid fa-exclamation-triangle text-amber-600 text-sm mt-0.5"></i>
                <p className="text-xs text-amber-800">
                  You can only pay for {remainingPeople} more {remainingPeople === 1 ? 'person' : 'people'}
                </p>
              </div>
            )}

            {/* All paid message */}
            {remainingPeople === 0 && (
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 flex items-start gap-2">
                <i className="fa-solid fa-info-circle text-blue-600 text-sm mt-0.5"></i>
                <p className="text-xs text-blue-800">
                  All {totalPeople} people have been paid for. The bill is fully covered!
                </p>
              </div>
            )}

            {/* Show minimum requirement info */}
            {!isTotalPeopleDisabled && (
              <div className="bg-purple-50 border border-purple-200 rounded-lg p-3 flex items-start gap-2">
                <i className="fa-solid fa-info-circle text-purple-600 text-sm mt-0.5"></i>
                <p className="text-xs text-purple-800">
                  <strong>Minimum requirements:</strong> 2 people at the table, paying for at least 1 person
                </p>
              </div>
            )}
          </div>

          <div className="px-5 space-y-4">
            {/* Payment Breakdown */}
            <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-xl p-4 space-y-2.5 border border-slate-200">
              {/* 1. Total Bill Amount (Without Tip) */}
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600 font-medium">
                  Total bill amount
                </span>
                <span className="text-base font-semibold text-gray-900">
                  ${total?.toFixed(2) || "0.00"}
                </span>
              </div> 

              {/* Show paid amount if there are previous transactions */}
              {previousTransactions && previousTransactions.length > 0 && (
                <>
                  <div className="h-px bg-slate-300"></div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600 font-medium flex items-center gap-1">
                      <i className="fa-solid fa-check-circle text-green-500 text-xs"></i>
                      Already paid ({peoplePaidFor} {peoplePaidFor === 1 ? 'person' : 'people'})
                    </span>
                    <span className="text-base font-semibold text-green-600">
                      -${totalPaid.toFixed(2)}
                    </span>
                  </div>
                </>
              )}

              <div className="h-px bg-slate-300"></div>

              {/* Split Details */}
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600 font-medium flex items-center gap-1">
                  <i className="fa-solid fa-users text-blue-500 text-xs"></i>
                  Split among {totalPeople} people
                  {isTotalPeopleDisabled && <i className="fa-solid fa-lock text-gray-500 text-xs ml-1"></i>}
                </span>
                <span className="text-base font-semibold text-blue-600">
                  ${((remainingCalvulation ? remainingDue: total) / totalPeople).toFixed(2)} per person
                </span>
              </div>

              {/* Remaining people info */}
              {peoplePaidFor > 0 && remainingPeople > 0 && (
                <>
                  <div className="h-px bg-slate-300"></div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600 font-medium flex items-center gap-1">
                      <i className="fa-solid fa-hourglass-half text-orange-500 text-xs"></i>
                      Remaining to pay
                    </span>
                    <span className="text-base font-semibold text-orange-600">
                      {remainingPeople} {remainingPeople === 1 ? 'person' : 'people'}
                    </span>
                  </div>
                </>
              )}

              <div className="h-px bg-slate-300"></div>

              {/* Your Share - includes both bill and tip */}
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600 font-medium flex items-center gap-1">
                  <i className="fa-solid fa-user text-purple-500 text-xs"></i>
                  Your share (for {payingFor} {payingFor === 1 ? 'person' : 'people'})
                </span>
                <span className="text-base font-semibold text-purple-600">
                  ${yourShare.toFixed(2)}
                </span>
              </div>

              {/* Show Tip Amount - This goes into Your Share */}
              {tipAmount > 0 && (
                <>
                  <div className="h-px bg-slate-300"></div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600 font-medium flex items-center gap-1">
                      <i className="fa-solid fa-heart text-red-500 text-xs"></i>
                      Tip amount 
                    </span>
                    <span className="text-base font-semibold text-green-600">
                      +${tipAmount.toFixed(2)}
                    </span>
                  </div>
                </>
              )}

              <div className="h-px bg-slate-300"></div>

              {/* Final Amount You're Paying */}
              <div className="flex justify-between items-center bg-white rounded-lg px-3 py-2 border border-slate-200">
                <span className="text-sm font-semibold text-gray-900">
                  You are paying
                  {tipAmount > 0 && <span className="text-xs text-gray-500 block">(bill + tip included)</span>}
                </span>
                <span className="text-lg font-bold text-green-600">
                  ${finalPayableAmount > 0 ? finalPayableAmount.toFixed(2) : "0.00"}
                </span>
              </div>              
            </div>

            {/* Info Notice - when paying for 0 people */}
            {payingFor === 0 && remainingPeople > 0 && (
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 flex items-start gap-2">
                <i className="fa-solid fa-exclamation-triangle text-amber-600 text-sm mt-0.5"></i>
                <p className="text-xs text-amber-800">
                  Please select at least 1 person you're paying for (max {remainingPeople})
                </p>
              </div>
            )}

            {/* Payment Section - Only show if paying for at least 1 person and there are remaining people */}
            {remainingPeople > 0 && payingFor >= 1 &&  (
              <div className="rounded-xl border border-gray-200 px-3 shadow-sm pt-5 pb-3 bg-slate-50/30">
                <Elements stripe={stripePromise}>
                  <CheckoutForm 
                    paymentType={paymentType} 
                    tableNumber={tableNumber}
                    orderId={orderId}
                    tipAmount={tipAmount}  
                    customPayAmount={yourShare}
                    noOfPerason={payingFor} 
                    totalPeople={totalPeople}             
                  />
                </Elements>

                <p className="text-[10px] text-gray-500 mt-3 text-center flex items-center justify-center gap-1">
                  <i className="fa-solid fa-shield-check text-green-600"></i>
                  100% Secure payments
                </p>
              </div>
            )}
          </div>
        </div>
      </BottomSheetModal>
    </>
  );
};

export default DivideBillEqualyNew;